import cn from 'classnames';
import Image from 'next/legacy/image';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  src: string;
  label: string;
  sizes?: string;
  selected: boolean;
  onSelect: () => void;
}

const SelectableCard: React.FC<Props> = ({ src, label, sizes, selected, onSelect }) => {
  return (
    <button
      className={cn(
        'focus-default w-full overflow-hidden rounded-sm shadow-lg lg:hover:shadow-sm',
        selected ? 'ring-primary-main ring-2' : 'ring-grey-100 ring-1'
      )}
      type="button"
      onClick={onSelect}
    >
      <div className="relative h-40">
        <Image
          src={src}
          layout="fill"
          sizes={sizes}
          objectFit="cover"
          objectPosition="center"
          alt={label}
        />
      </div>
      <div className="text-primary-main px-2 py-2 text-center font-medium">
        <FormattedMessage id={`subscription-funnel:${label}`} />
      </div>
    </button>
  );
};

export default SelectableCard;
